"use client";

import { useState } from "react";
import { signIn } from "next-auth/react";
import { Button } from "@/components/ui/button";

/** Microsoft SSO を開始し、ログイン後は元の画面へ戻す。 */
export function LoginForm({ callbackUrl = "/", expired = false, failed = false }: Readonly<{
  callbackUrl?: string; expired?: boolean; failed?: boolean;
}>) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(failed);
  async function login() {
    setLoading(true);
    setError(false);
    try {
      await signIn("microsoft-entra-id", { redirectTo: callbackUrl });
    } catch {
      setError(true);
      setLoading(false);
    }
  }
  return (
    <section className="w-full max-w-md space-y-6 rounded-xl border bg-card p-8 shadow-sm">
      <div className="space-y-2">
        <p className="text-sm font-medium text-muted-foreground">Nexus</p>
        <h1 className="text-2xl font-semibold">ログイン</h1>
        <p className="text-sm text-muted-foreground">会社のMicrosoftアカウントでログインしてください。</p>
      </div>
      {expired && <p role="status" className="text-sm">セッションの有効期限が切れました。再度ログインすると、元の画面に戻ります。</p>}
      {error && <p role="alert" className="text-sm text-destructive">ログインできませんでした。再試行するか、運用者にお問い合わせください。</p>}
      <Button className="w-full" onClick={login} disabled={loading}>
        {loading ? "Microsoftへ移動中…" : "Microsoftでログイン"}
      </Button>
    </section>
  );
}
